<template>
  <el-table-column label="" width="70px">
    <template slot-scope="scope">
      <K2Row justify_content="center">
        <el-checkbox
          v-model="scope.checked"
          @change="$emit('termGoalChangeColumn', [scope.row.PlnMasID, term + 1, scope.checked])"
          :key="goalRefresh"
          :checked="ddlTermGoalsList.indexOf(scope.row.PlnMasID) !== -1"
          :disabled="disabled || ddlTermClassGoalsList.includes(scope.row.PlnMasID)"
          v-bind:class="getClass()"
        ></el-checkbox>
      </K2Row>
    </template>
  </el-table-column>
</template>

<script>
import K2ToolTip from '@/uiComponents/k2ToolTip/k2ToolTip'
import K2Icon from '@/uiComponents/k2Icon/k2MAIcon'
import K2Row from '@/uiComponents/k2Row/k2Row'
import uiVariable from '@/config/uiVariable'
import { lang } from '@/locale'

export default {
  name: 'PlannerTableColumn',
  components: { K2ToolTip, K2Icon, K2Row },
  props: {
    domainGoalList: {
      type: Array,
    },
    goalRefresh: {
      type: Number,
    },
    ddlTermGoalsList: {
      type: Array,
    },
    ddlTermClassGoalsList: {
      type: Array,
    },
    term: {
      type: Number,
    },
    classname: {
      type: String,
    },
    disabled: true,
  },
  data() {
    return {
      uiVariable: uiVariable,
    }
  },
  methods: {
    lang,
    getClass() {
      let className = this.classname

      return className
    },
  },
}
</script>

<style scoped></style>
